import React from 'react';
import { Text, View } from 'react-native';
import { Card } from 'react-native-paper';
// Common components
import { LabeledField } from '../components/LabeledField';
import { TEXT_FIELD_WIDTH } from '../components/consts';
import { styles } from './ProfileViewStyle';
import { FormCard } from './FormCard';
export const MealsCard = ({ readOnly }) => {
    return (<FormCard>
      <Card.Content>
        <Text style={styles.labelText}>
          What do you currently eat on weekdays?
        </Text>
        <View style={styles.mealsFieldsContainer}>
          <LabeledField name="breakfastDesc" placeholder="Breakfast?" width={TEXT_FIELD_WIDTH} height={50} multiline={true} readOnly={readOnly}/>
          <LabeledField name="lunchDesc" placeholder="Lunch?" width={TEXT_FIELD_WIDTH} height={50} multiline={true} readOnly={readOnly}/>
          <LabeledField name="dinnerDesc" placeholder="Dinner?" width={TEXT_FIELD_WIDTH} height={50} multiline={true} readOnly={readOnly}/>
          <LabeledField name="snacksDesc" placeholder="Snacks?" width={TEXT_FIELD_WIDTH} height={50} multiline={true} readOnly={readOnly}/>
        </View>
        <Text style={styles.labelText}>
          What do you eat on weekends, if different?
        </Text>
        <View style={styles.mealsFieldsContainer}>
          <LabeledField name="weekendMealsDesc" placeholder="List them" width={TEXT_FIELD_WIDTH} height={50} multiline={true} readOnly={readOnly}/>
        </View>
      </Card.Content>
    </FormCard>);
};
